module.exports = __webpack_public_path__ + "static/retention-3c13931068b0d66f0153c9c587d017b3.jpg";